/**
 * Shared by the Create Role (Roles.jsx) and Edit Role (CardRole.jsx) modals.
 */

// Manage beats Read-Only, and View All beats Own or Assigned (OL-218).
const optionRank = (name = '') => {
  if (name.startsWith('manage-')) return 0;
  if (name.startsWith('view-all-')) return 1;
  return 2;
};

/** The highest-level option of a module, or undefined when it has none. */
export const highestOption = (options = []) =>
  [...options].sort((a, b) => optionRank(a.name) - optionRank(b.name))[0];

/**
 * Everything Select All ticks: each module, its highest option, every child,
 * and Administrator Access. It used to take each module's first option, the
 * lowest level for Invoices and Notifications (OL-218).
 */
export const selectAllPermissions = (permissionData) => {
  const names = Object.values(permissionData || {})
    .flat()
    .flatMap((perm) => {
      const picked = perm.name ? [perm.name] : [];
      const best = highestOption(perm.options);
      if (best) picked.push(best.name);
      (perm.children || []).forEach((child) => picked.push(child.name));
      return picked;
    });

  return [...new Set([...names, 'is_admin_access'])].map((name) => ({ name }));
};

/**
 * Field errors for Formik and one line for the toast when a role fails to
 * save. Errors on keys the form has no field for (permissions.3) used to
 * vanish, so the first message always reaches the toast.
 */
export const describeRoleSaveError = (error, fallback) => {
  const fieldErrors = Object.fromEntries(
    Object.entries(error?.errors || {}).map(([key, value]) => [key, Array.isArray(value) ? value[0] : value])
  );
  const firstFieldError = Object.values(fieldErrors)[0];
  const serverMessage = error?.errors ? null : error?.message || error?.customMessage;

  return { fieldErrors, message: firstFieldError || serverMessage || fallback };
};
